import { ReactNode } from 'react';
import { BoxProps, Stack } from '@mui/material';
import { Box, Card, Divider, Typography } from '@occc-app/design-system';

type OfferConfigurationSectionProps = BoxProps & {
  title: string;
  children: ReactNode;
};

export const OfferConfigurationSection = ({
  title,
  children,
  ...props
}: OfferConfigurationSectionProps) => (
  <Box mb={2} {...props}>
    <Typography variant='subtitle1' gutterBottom>
      {title}
    </Typography>
    <Card sx={{ mb: 0 }}>
      <Stack divider={<Divider />}>{children}</Stack>
    </Card>
  </Box>
);
